var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_2955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7734 5.08594V14.6859C24.7734 16.8951 19.4009 18.6859 12.7734 18.6859C6.14602 18.6859 0.773438 16.8951 0.773438 14.6859V5.08594",
    fill: "#FFDB2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 5.08594V18.6859C19.4009 18.6859 24.7734 16.8951 24.7734 14.6859V5.08594H12.7734Z",
    fill: "#FFAF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 9.08591C19.4009 9.08591 24.7734 7.29505 24.7734 5.08592C24.7734 2.87679 19.4009 1.08594 12.7734 1.08594C6.14602 1.08594 0.773438 2.87679 0.773438 5.08592C0.773438 7.29505 6.14602 9.08591 12.7734 9.08591Z",
    fill: "#FFEA8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 1.08594V9.08595C19.4009 9.08595 24.7734 7.29509 24.7734 5.08597C24.7734 2.87684 19.4009 1.08594 12.7734 1.08594Z",
    fill: "#FFDB2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 12.6865C6.14602 12.6865 0.773438 10.8957 0.773438 8.68652V12.5149C1.48064 12.9755 2.38294 13.4097 3.52922 13.7918C6.03403 14.6267 9.31697 15.0866 12.7734 15.0866C16.2299 15.0866 19.5129 14.6267 22.0177 13.7918C23.164 13.4097 24.0663 12.9755 24.7734 12.5149V8.68652C24.7734 10.8957 19.4009 12.6865 12.7734 12.6865Z",
    fill: "#FFAF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 12.6865V15.0865C16.2299 15.0865 19.5129 14.6267 22.0177 13.7918C23.164 13.4097 24.0663 12.9755 24.7734 12.5148V8.68652C24.7734 10.8957 19.4009 12.6865 12.7734 12.6865Z",
    fill: "#FF9408"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_2955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.3529,
    fill: "white",
    transform: "translate(0.773438 0.709961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinGold);
export default __webpack_public_path__ + "static/media/coin-gold.66fa7d6a789e2dad6eb7a04785f0b7e5.svg";
export { ForwardRef as ReactComponent };